import { defineMessages } from 'react-intl';


const COMMON_MESSAGES = defineMessages({
    NAME: {
        id: 'InsCommon.CommonMessages.Name',
        defaultMessage: 'Name',
    },
    DATE_OF_BIRTH: {
        id: 'InsCommon.CommonMessages.DateOfBirth',
        defaultMessage: 'Date of birth',
    },
    PHONE: {
        id: 'InsCommon.CommonMessages.Phone',
        defaultMessage: 'Phone',
    },
    PHONE_TOOLTIP: {
        id: 'InsCommon.CommonMessages.Phone.Tooltip',
        defaultMessage: 'Please note that upon requesting to receive more information about a quote, expect one of our verified partners to contact you by either phone, text and/or email within 2 business days to provide you with additional details - including potential discount opportunities. You are under no obligation to purchase.',
    },
    EMAIL: {
        id: 'InsCommon.CommonMessages.Email',
        defaultMessage: 'Email',
    },
    EMAIL_TOOLTIP: {
        id: 'InsCommon.CommonMessages.Email.Tooltip',
        defaultMessage: 'Don’t worry, we’ll only send you information specific to your quote unless you sign up for more.',
    },
    YES: {
        id: 'InsCommon.CommonMessages.Yes',
        defaultMessage: 'Yes',
    },
    NO: {
        id: 'InsCommon.CommonMessages.No',
        defaultMessage: 'No',
    },
});

const COMMON_BUTTON_MESSAGES = defineMessages({
    SAVE: {
        id: 'InsCommon.ButtonMessages.Save',
        defaultMessage: 'Save & exit',
    },
    UPDATE: {
        id: 'InsCommon.ButtonMessages.Update',
        defaultMessage: 'Update',
    },
    CONTINUE: {
        id: 'InsCommon.ButtonMessages.Continue',
        defaultMessage: 'Continue',
    },
    CALL_NOW: {
        id: 'InsCommon.ButtonMessages.CallNow',
        defaultMessage: 'Call now',
    },
    SCHEDULE_CALL: {
        id: 'InsCommon.ButtonMessages.ScheduleCall',
        defaultMessage: 'Schedule a call',
    },
    SEE_QUOTES: {
        id: 'InsCommon.ButtonMessages.SeeMyQuotes',
        defaultMessage: 'See my quotes',
    },
});

const SIGN_IN_MESSAGES = defineMessages({
    MAGIC_LINK_SIGN_IN_TITLE: {
        id: 'InsCommon.MagicLinkSignIn.Title',
        defaultMessage: 'Enter your email to save your current insurance quote progress',
    },
    DESCRIPTION: {
        id: 'InsCommon.MagicLinkSignIn.Description',
        defaultMessage: 'Your complete insurance quoting history, including in-progress and complete quotes, will be stored and accessible via a Ratehub account. We will send you an email with a secure sign-in link to complete this process. Please click on the link to access your account.',
    },
});

export {
    COMMON_MESSAGES,
    COMMON_BUTTON_MESSAGES,
    SIGN_IN_MESSAGES,
};